export type ProjectLangSwitcherCode = 'ru' | 'en';

export const getProjectLangSwitcherPrimaryCode = (): ProjectLangSwitcherCode => 'ru';

export const getProjectLangSwitcherActiveCode = (uiLang: string): ProjectLangSwitcherCode =>
  uiLang === 'en' ? 'en' : 'ru';

export const getProjectLangSwitcherBadge = (code: ProjectLangSwitcherCode): string =>
  code === 'en' ? 'EN' : 'RU';

export const getProjectLangSwitcherPrimaryLabel = (
  t: (key: string) => string
): string => t('project_edit.language_switcher.ru');

export const getProjectLangSwitcherSecondaryLabel = (
  t: (key: string) => string
): string => t('project_edit.language_switcher.en');

export const normalizeProjectLangSwitcherCode = (lang: string): ProjectLangSwitcherCode =>
  lang === 'en' ? 'en' : 'ru';
export type ProjectLangSwitcherCode = 'ru' | 'en';

export const getProjectLangSwitcherPrimaryCode = (): ProjectLangSwitcherCode => 'ru';

export const getProjectLangSwitcherActiveCode = (uiLang: string): ProjectLangSwitcherCode =>
  uiLang === 'en' ? 'en' : 'ru';

export const getProjectLangSwitcherBadge = (code: ProjectLangSwitcherCode): string =>
  code === 'en' ? 'EN' : 'RU';

export const getProjectLangSwitcherPrimaryLabel = (
  t: (key: string) => string
): string => t('project_edit.language_switcher.ru');

export const getProjectLangSwitcherSecondaryLabel = (
  t: (key: string) => string
): string => t('project_edit.language_switcher.en');

export const normalizeProjectLangSwitcherCode = (lang: string): ProjectLangSwitcherCode =>
  lang === 'en' ? 'en' : 'ru';
